import React, { Component } from "react";
import { List, Typography } from "antd";
import { ModalItem, ButtonItem } from "../../../../Components/Items";

class ModalInsumosSinRelacion extends Component {
  render() {
    const { 
      visible, 
      onCancel, 
      insumosSinRelacion, 
      onRelacionarClick 
    } = this.props;

    return (
      <ModalItem
        title="Insumos Faltantes de Relacionar"
        visible={visible}
        onCancel={onCancel}
        width={600}
        spinning={false}

      >
        <div style={{ padding: "0 15px 15px 15px" }}>
          <p>
            Los siguientes insumos pertenecen a la orden de eCommerce, pero aún no están relacionados con el proveedor seleccionado. Relaciónalos para poder agregarlos a la Orden de Compra.
          </p>
          <List
            bordered
            dataSource={insumosSinRelacion}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <ButtonItem
                    type="primary"
                    size="small"
                    onClick={() => onRelacionarClick(item)}
                  >
                    Relacionar
                  </ButtonItem>,
                ]}
              >
                <List.Item.Meta
                  title={
                    <Typography.Text strong>
                      {item.descripcion || item.leyenda}
                    </Typography.Text>
                  }
                  description={`Cantidad a pedir: ${item.cantidad}`}
                />
              </List.Item>
            )}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
            <ButtonItem onClick={onCancel} rojo>
              Cerrar
            </ButtonItem>
          </div>
        </div>
      </ModalItem>
    );
  }
}

export default ModalInsumosSinRelacion;